import { put, takeEvery, all } from 'redux-saga/effects';
import { delay } from 'redux-saga';
import { logger } from '../../helpers/logger';
import actions from './actions';

function* handleDelayTimer(data) {
  try {
    yield delay(5000);

    yield put({ type: actions.DISMISS_NOTIFICATION, payload: data.payload.id });
  } catch (error) {
    logger.error(error);
  }
}

export { handleDelayTimer };
export default function* rootSaga() {
  yield all([
    takeEvery(actions.ADD_NOTIFICATION, handleDelayTimer),
    takeEvery(actions.REQUEST_ERROR, handleDelayTimer),
  ]);
}
